"use client"

import {
  Control,
  FieldValues,
  Path
} from "react-hook-form"

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/shared/shadcn/ui/form"
import { Input } from "@/shared/shadcn/ui/input"

type FormInputProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  label: string;
  placeholder: string;
  control: Control<TFieldValues>;
  type: string;
  required?: boolean;
  disabled?: boolean;
}

export default function FormInput<TFieldValues extends FieldValues>({
  name,
  label,
  placeholder,
  control,
  type,
  required = false,
  disabled = false,
}: FormInputProps<TFieldValues>) {
  return (
    <FormField
      control={control}
      disabled={disabled}
      name={name}
      render={({ field }) => (
        <FormItem className="my-3">
          <div className="flex flex-row items-center gap-x-1">
            <FormLabel className="text-xs">
              {label}
            </FormLabel>
            {required && <span className="text-[#F04438]">*</span>}
          </div>
          <FormControl>
            <Input
              className="bg-bg-primary-alt border-border-primary p-4"
              placeholder={placeholder}
              type={type}
              {...field}
            />
          </FormControl>
          <FormMessage className="text-red-400" />
        </FormItem>
      )}
    />
  )
}
